import { httpClient } from '../../httpClient/httpClient';
import { FileLink } from '../filesApi';

export enum CaptureSessionType {
  ProductApproval = 1,
  VariantComposition = 2,
  ArticleVariantPhoto = 3,
  ArticleVariantArtwork = 4,
  ArticleVariantCellPhoto = 5,
}

export interface InitializeCaptureSessionRequest {
  referenceId: number;
  referenceType: CaptureSessionType;
}
export interface InitializeCaptureSessionResponse {
  sessionId: string;
  qrCodeBase64: string;
  redirectUrl: string;
}

export interface CaptureSessionStatusRequest {
  referenceId: number;
  referenceType: CaptureSessionType;
  sessionId: string;
}

export interface CaptureSessionStatusResponse {
  hasPhoto: boolean;
  file: FileLink | null;
  uploadedAt: string | null;
}

export interface UploadCapturePhotoResponse {
  success: boolean;
  fileId: number;
  fileIdentifier: string;
}

export const captureApi = {
  initializeCaptureSession: (request: InitializeCaptureSessionRequest) => {
    return httpClient.post<InitializeCaptureSessionResponse>(
      `/capture/session/initialize`,
      { data: request },
    );
  },

  getCaptureSessionStatus: (request: CaptureSessionStatusRequest) => {
    return httpClient.post<CaptureSessionStatusResponse>(
      `/capture/session/status`,
      { data: request },
    );
  },

  uploadCapturePhoto: (sessionId: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    return httpClient.post<UploadCapturePhotoResponse>(
      `/capture/${sessionId}/photo`,
      { data: formData },
    );
  },
};
